import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import find from 'lodash/find';
import { includes } from 'lodash';
import { useAction } from 'hooks/useAction';
import App from 'modules/App';
import Information from 'modules/Information';
import { SIGN_UP_FORM } from '../../../constants';
export const useSetCountry = ()=>{
    const regions = useSelector(App.selectors.regions);
    const countries = useSelector(App.selectors.countries);
    const setRegion = useAction(App.actions.setRegion);
    const setFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    const fetchConsentsTemplate = useAction(Information.actions.fetchConsentsTemplate);
    return useCallback((input, appSKUCountryCode)=>{
        let alpha2Code = input.value;
        const country = find(countries, {
            alpha2Code
        });
        const region = find(regions, (r)=>includes(r.countries, alpha2Code));
        if (!country || !region) return;
        if (appSKUCountryCode) {
            alpha2Code = appSKUCountryCode;
            const appSKUCountry = find(countries, {
                alpha2Code
            });
            const appSKURegion = find(regions, (r)=>includes(r.countries, appSKUCountryCode));
            if (!appSKUCountry || !appSKURegion) return;
        }
        fetchConsentsTemplate(alpha2Code);
        setRegion(alpha2Code);
        setFormValue(input);
    }, [
        countries,
        regions
    ]);
};
